module.exports = __webpack_public_path__ + "static/img/i5.5ce6da6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/i5.png
// module id = VRyi
// module chunks = 0